/*
 * Spriteが削除されたときdefsタグを削除するかどうか管理する
 * 画面上に１つでもアイテムが残ってる場合はdefsタグを消してはいけない為
 * addChildされているアイテムを管理する
 *
 * defsタグ自体の操作もこちらが行う(インスタンス保持など)
 */
export default class SVGSpriteManager {
  private static _instance: SVGSpriteManager;

  private uniqueIndex: number;

  constructor() {
    this.uniqueIndex = 0;
  }

  public static get instance(): SVGSpriteManager {
    if (SVGSpriteManager._instance == null) {
      SVGSpriteManager._instance = new SVGSpriteManager();
    }

    return SVGSpriteManager._instance;
  }

  public appendItem(): number {
    this.uniqueIndex += 1;
    return this.uniqueIndex;
  }
}
